import { IStatementColumns, IStatementLine } from "shared";

import { classNames } from "../../../../common/lib/classNames";

import { StatementLine } from "./StatementLine";

export interface IStatementGroupHeading {
  label: string;
  total: string;
  /** Due now / not yet due groups get a dot, child contacts a grey box */
  dot?: `red` | `grey`;
  child?: boolean;
}

interface IStatementLinesProps {
  lines: IStatementLine[];
  heading?: IStatementGroupHeading;
  columnSettings: IStatementColumns;
  showPayColumn?: boolean;
  organisationTimezone: string;
  downloadingInvoices?: Record<string, boolean>;
  selectedInvoiceIds: string[];
  onToggle: (line: IStatementLine) => void;
  onDownload: (line: IStatementLine) => void;
  onOpen: (line: IStatementLine) => void;
}

export function StatementLines({
  lines,
  heading,
  columnSettings,
  showPayColumn,
  organisationTimezone,
  downloadingInvoices,
  selectedInvoiceIds,
  onToggle,
  onDownload,
  onOpen,
}: IStatementLinesProps) {
  if (!lines.length) {
    return null;
  }

  const colSpan = columnSettings.length + 2 + (showPayColumn ? 1 : 0);

  return (
    <tbody>
      { heading && (
        <tr>
          <td
            colSpan={ colSpan }
            className={ heading.child ? `pt-3` : `border-b border-gray-200 px-3.5 pb-1.5 pt-4` }
          >
            <div className={ classNames(
              `flex items-center justify-between gap-3`,
              heading.child
                ? `rounded-lg border border-gray-100 bg-gray-50 px-3.5 py-2 text-[0.8125rem] font-semibold text-gray-900`
                : `text-xs font-semibold uppercase tracking-[0.04em] text-gray-500`,
            ) }>
              <span className={ `flex items-center gap-2` }>
                { heading.dot && (
                  <span className={ classNames(`h-2 w-2 rounded-full`, heading.dot === `red` ? `bg-paidniceRed-600` : `bg-paidniceGreen-300`) } />
                ) }
                { heading.label }
              </span>
              <span className={ classNames(
                `text-[0.8125rem] tabular-nums normal-case tracking-normal text-gray-700`,
                heading.child && `font-medium`,
              ) }>
                { heading.child ? `Subtotal ${heading.total}` : heading.total }
              </span>
            </div>
          </td>
        </tr>
      ) }
      { lines.map((line, idx) => (
        <StatementLine
          key={ `${line.invoiceId}-${idx}-statement-line` }
          line={ line }
          showPayColumn={ showPayColumn }
          organisationTimezone={ organisationTimezone }
          columnSettings={ columnSettings }
          downloading={ downloadingInvoices?.[line.invoiceId] }
          selected={ selectedInvoiceIds.includes(line.invoiceId) }
          onToggle={ onToggle }
          onDownload={ onDownload }
          onOpen={ onOpen }
        />
      )) }
    </tbody>
  );
}
